const WsActivity = {
  A0: { label: 'Kvar na cjevovodu', value: 0 },
  A1: { label: 'Kvar na priključnom cjevovodu', value: 1 },
  A2: { label: 'Zamjena dijela cjevovoda', value: 2 },
  A3: { label: 'Zamjena/izmještanje dijela priključnog cjevovoda', value: 3 },
  A4: {
    label: 'Zamjena ventila i fitinga u vodomjernom šahtu',
    value: 4,
  },
  A5: {
    label: 'Zamjena/montaža vodomjera u šahtu',
    value: 5,
  },
  A6: { label: 'Izrada novog priključka', value: 6 },
  A7: { label: 'Detekcija curenja/mjerenje protoka UZM', value: 7 },
  A8: { label: 'Popravak ventila/zatvarača', value: 8 },
  A9: { label: 'Zamjena ventila/zatvarača', value: 9 },
  A10: { label: 'Rekonstrukcija fazonskih komada i armatura', value: 10 },
  A11: {
    label: 'Održavanje zone rezervoara',
    value: 11,
  },
  A12: { label: 'Pranje rezervoara', value: 12 },
  A13: { label: 'Ostali radovi - rezervoar', value: 13 },
  A14: { label: 'Popravka/zamjena pumpe', value: 14 },
  A15: {
    label: 'Ostali radovi na pumpnoj stanici',
    value: 15,
  },
  A16: { label: 'Zamjena/popravka reducir ventila', value: 16 },
  A17: { label: 'Sanacija/dogradnja vodovodnog šahta', value: 17 },
  A18: { label: 'Popravka/zamjena hidranta', value: 18 },
  A19: { label: 'Ostalo', value: 19 },
};

export default WsActivity;
